import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoaderComponent } from './loader/loader.component';
import { AlertdialogueComponent } from './dialogues/alertdialogue/alertdialogue.component';
import { FacilityPipe } from './pipes/facility.pipe';
import { ComplianceDialogComponent } from './dialogues/compliancedialog/compliancedialog.component';
import { InfoDialogueComponent } from './dialogues/infodialog/infodialog.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NoInternetComponent } from './no-internet/no-internet.component';
import { DetailsDialogComponent } from './dialogues/detailsdialog/detailsdialog.component';
import { AddforcheckoutComponent } from './dialogues/addforcheckout/addforcheckout.component';
import { FailedCheckoutDetailsComponent } from './dialogues/failed-checkout-details/failed-checkout-details.component';
import { GroupNameComponent } from './dialogues/group-name/group-name.component';
import { FilterPipe } from './pipes/filter.pipe';
import { ConfirmComponent } from './dialogues/confirm/confirm.component';
import { CityPipe } from './pipes/city.pipe';
import { GroupDetailsComponent } from './dialogues/group-details/group-details.component';
import { ImagePreviewComponent } from './dialogues/image-preview/image-preview.component';
import { WorkingstatusimagePipe } from './pipes/workingstatusimage.pipe';
import { CheckInOutdialogComponent } from './dialogues/check-in-outdialog/check-in-outdialog.component';
import { CustomCountPipe } from './pipes/custom-count.pipe';
import { SiteRedinessdialogComponent } from './dialogues/site-redinessdialog/site-redinessdialog.component';
import { BannerpreviewdialogComponent } from './dialogues/bannerpreviewdialog/bannerpreviewdialog.component';
import { TranslocoModule } from '@ngneat/transloco';
import { UploadExceldialogComponent } from './dialogues/upload-exceldialog/upload-exceldialog.component';
import { SafeUrlPipe } from './pipes/safeurl.pipe';
import { FacilityfordropdownPipe } from './pipes/facilityfordropdown.pipe';
import { UserfordropdownPipe } from './pipes/userfordropdown.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { JobtitlePipe } from './pipes/jobtitle.pipe';
import { MysiteCountPipe } from './pipes/mysite-count.pipe';
import { InstalldialogComponent } from './dialogues/installdialog/installdialog.component';
import { WorkingStatusPipe } from '../feature/history/pipes/working-status.pipe';
import { RiskCalculatorComponent } from './components/risk-calculator/risk-calculator.component';
import { FacilityTypePipe } from './pipes/facilitytype.pipe';
import { RiskLevelPipe } from './pipes/risklevel.pipe';
import { CustomlengthPipe } from './pipes/customlength.pipe';
import { CardTemplateComponent } from '../feature/approvals/templates/card-template/card-template.component';
import { StatusComponent } from '../feature/approvals/templates/status/status.component';
import { AddDialogComponent } from './dialogues/adddialog/adddialog.component';
import { HealthExposureInstructionsComponent } from './dialogues/health-exposure-instructions/health-exposure-instructions.component';
import { WorkingStatusEvacuationAlertComponent } from './dialogues/working-status-evacuation-alert/working-status-evacuation-alert.component';
import { ImagePreviewerComponent } from './dialogues/image-previewer/image-previewer.component';
import { SecurityRiskTooltipComponent } from '../feature/pre-trip/templates/security-risk-tooltip/security-risk-tooltip.component';

@NgModule({
  declarations: [
    AddDialogComponent,
    JobtitlePipe,
    LoaderComponent,
    FacilityPipe,
    UserfordropdownPipe,
    AlertdialogueComponent,
    InfoDialogueComponent,
    ComplianceDialogComponent,
    PageNotFoundComponent,
    NoInternetComponent,
    DetailsDialogComponent,
    AddforcheckoutComponent,
    FailedCheckoutDetailsComponent,
    GroupNameComponent,
    ConfirmComponent,
    FilterPipe,
    CityPipe,
    CustomCountPipe,
    GroupDetailsComponent,
    ImagePreviewComponent,
    CheckInOutdialogComponent,
    WorkingstatusimagePipe,
    SiteRedinessdialogComponent,
    BannerpreviewdialogComponent,
    UploadExceldialogComponent,
    SafeUrlPipe,
    CustomlengthPipe,
    FacilityfordropdownPipe,
    MysiteCountPipe,
    InstalldialogComponent,
    WorkingStatusPipe,
    RiskCalculatorComponent,
    FacilityTypePipe,
    RiskLevelPipe,
    CardTemplateComponent,
    StatusComponent,
    HealthExposureInstructionsComponent,
    WorkingStatusEvacuationAlertComponent,
    ImagePreviewerComponent,
    SecurityRiskTooltipComponent,
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    FlexLayoutModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoModule
  ],
  exports: [
    SecurityRiskTooltipComponent,
    HealthExposureInstructionsComponent,
    WorkingStatusEvacuationAlertComponent,
    MysiteCountPipe,
    JobtitlePipe,
    ScrollingModule,
    UserfordropdownPipe,
    CommonModule,
    FlexLayoutModule,
    MaterialModule,
    FacilityPipe,
    FacilityfordropdownPipe,
    ReactiveFormsModule,
    FormsModule,
    LoaderComponent,
    NoInternetComponent,
    DetailsDialogComponent,
    AddforcheckoutComponent,
    FilterPipe,
    CustomCountPipe,
    CityPipe,
    SafeUrlPipe,
    WorkingstatusimagePipe,
    CustomlengthPipe,
    FacilityfordropdownPipe,
    TranslocoModule,
    WorkingStatusPipe,
    RiskCalculatorComponent,
    FacilityTypePipe,
    RiskLevelPipe,
    CardTemplateComponent,
    StatusComponent,
    AddDialogComponent
  ]
})
export class SharedModule { }
